// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e_mQ","label":"styles_label__k2YHL"};